import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ModalComponent, ModalConfig } from '../modal/modal.component';
import { User } from '../models/user.model';
import { AuthService } from '../services/auth.service';
import { StorageService } from '../services/local-storage.service';
import { PasswordValidator } from '../services/utils/checkPasswords';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
  tabActive: Array<String> = ["", ""];
  user: User;
  @ViewChild('modal') private modalComponent: ModalComponent
  modalConfig: ModalConfig;
  formEditPassword: FormGroup;
  submitted = false;
  fieldTextType: boolean = false;
  language: string = "EN"
  constructor(private router: Router, public authService: AuthService, private translate: TranslateService,
    private formBuilder: FormBuilder, public localStorage: StorageService) {
  }

  ngOnInit(): void {
    this.translate.get("home").subscribe((text) => {
      this.modalConfig = {
        modalTitle: text.changePassword, modalSubTitle: text.modify,
        modalText: text.requireMessage
      };
    });

    this.user = this.localStorage.getCurrentSession().user
    if (this.router.url === "/home/shipment")
      this.setActiveTab(1)
    else
      this.setActiveTab(2)

    this.formEditPassword = this.formBuilder.group(
      {
        current_pass: [
          '', Validators.required],
        new_pass: [
          '', [Validators.required, Validators.minLength(6), Validators.maxLength(16)]
        ],
        confirm_pass: [
          '', Validators.required
        ],

      }, {
      validator: PasswordValidator.matchPwds
    }
    );
  }
  get f(): { [key: string]: AbstractControl } {
    return this.formEditPassword.controls;
  }
  isActive(num) {
    return this.tabActive[num]
  }
  toggleFieldTextType() {
    this.fieldTextType = !this.fieldTextType;
  }
  initTabs() {
    this.tabActive = ["", ""]
  }
  async openChangePassword() {
    this.formEditPassword.controls['current_pass'].setValue( "");
    this.formEditPassword.controls['new_pass'].setValue( "");
    this.formEditPassword.controls['confirm_pass'].setValue("");
    this.translate.get("home").subscribe((text) => {
      this.modalConfig = {
        modalTitle: text.changePassword, modalSubTitle: text.modify,
        modalText: text.requireMessage
      };
    });
    return await this.modalComponent.open()
  }
  logout() {
    this.authService.SignOut();
  }
  changePassword() {
    this.submitted = true
    let data = {
      passwordOld: this.formEditPassword.value.current_pass,
      password: this.formEditPassword.value.new_pass,
      userMod: this.localStorage.getCurrentUser().userName
    }

    this.authService.updatePassword(data).then(res => {
      this.formEditPassword.reset();
      return this.modalComponent.dismiss()
    })
  }
  async setActiveTab(num) {
    await this.initTabs();
    this.tabActive[num] = "itemActive"
  }
  get confirmPass() {

    return this.formEditPassword.get('confirm_pass');
  }
  get newPass() {

    return this.formEditPassword.get('new_pass');
  }
  useLanguage(language: string): void {
    this.language = language.toUpperCase();
    this.translate.use(language);
  }
}
